import { component } from "picoapp";

export default component(async (node) => {
  const [{ default: KeenSlider }, { useFade, useDots }] = await Promise.all([
    import("keen-slider"),
    import("../lib/keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const sliderElement = node.querySelector("[data-keen-slider]");
  const buttons = node.querySelectorAll("[data-button]");
  const dotsContainer = node.querySelector(".dots");

  const slider = new KeenSlider(
    sliderElement,
    {
      loop: false,
      drag: false,
      slideChanged: (s) => {
        s.slides.forEach((element, index) => {
          const button = node.querySelector(
            `[data-button][data-index="${index}"]`
          );
          if (slider.track.details.rel === index) {
            element.classList.add("selected");
            button.classList.add("selected");
          } else {
            element.classList.remove("selected");
            button.classList.remove("selected");
          }
        });
      },
      useFade: {
        duration: "0.1s",
        timingFunction: "linear",
      },
      created: (i) => i.container.classList.remove("hide-init"),
    },
    [useFade, useDots(dotsContainer)]
  );

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const index = button.dataset.index;
      slider.moveToIdx(parseInt(index));
    });
  });
});
